import { Component } from '@angular/core';
import { ThemeService } from '@infra/theme/theme.service';
import { AuthService } from './infra/auth/auth.service';
import { NavService } from './infra/nav/nav.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'front-portal-cliente-angular';

  constructor(
    themeService: ThemeService,
    public authService: AuthService,
    public navService: NavService
  ) {
    themeService.initialize();
  }
}
